import { Injectable, Inject } from "@angular/core";
import { LoiHttpClient } from "loi-lti-common";
import { Observable } from "rxjs";
import { CustomRequestOptions } from "../utils/custom-request-options";

@Injectable({
  providedIn: 'root'
})

export class MembershipService {
  constructor(
    private httpClient: LoiHttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private requestOptions: CustomRequestOptions) { }

  createMembership(moduleId, contractId: string): Observable<boolean> {
    console.log(`creating membership (activation) for module ${moduleId} and contract ${contractId}`);
    return this.httpClient.post<boolean>(`${this.baseUrl}api/Activation/membership/module/create/${moduleId}/${contractId}`, { });
  }

  hasMembership(moduleId): Observable<boolean> {
    console.log(`check if student has membership (activation) for module ${moduleId}`);
    return this.httpClient.get<boolean>(`${this.baseUrl}api/Activation/membership/module/${moduleId}`, this.requestOptions);
  }
}
